"use strict";

import angular from "angular";

function emailExistsDirective() {
    return {
        restrict: "A",
        require: "?ngModel",
        link: function (scope, element, attrs, ctrl) {
            element.on("change", function () {
                scope.$apply(function () {
                    ctrl.$setValidity("emailExist", true);
                });
            });
        }
    };
}

const name = "emailExists";
const factory = emailExistsDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
